/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import SignalsHeader from "./SignalHeader";
import SignalsBody from "./SignalsBody";
import { useSignalAutomations } from "../../hooks/QueryHooks";
import EmptySignalPlaceholder from "./EmptySignalPlaceholder";
import cn from "../../utils/styleHelpers";

type Props = {
  bodyClass?: string,
  workspace: any,
  onAccountClick: (acc: any, signal: any, select: boolean, entity: string) => void,
  selectedSignal?: string | null,
  onTabClick?: any,
  accountSignal?: boolean
  accountId?: string | null,
  navTo?: "inbox" | "signals",
  user?: string,
  tableHeight?: number,
  showTitle?: boolean,
  containerClass?: string,
};

const SignalsContainer = ({
  bodyClass,
  containerClass,
  workspace,
  onAccountClick,
  selectedSignal,
  onTabClick = () => {},
  accountSignal = false,
  accountId = null,
  navTo = "inbox",
  user,
  tableHeight,
  showTitle = true,
}: Props) => {
  const [period, setPeriod] = useState<any>("last_30_days");
  const [playbookId, setPlaybookId] = useState<any>();
  const [signalStatus, setSignalStatus] = useState<any>();
  const [automationId, setAutomationId] = useState<any>();
  const [owner, setOwner] = useState<any>(!user ? [] : ["unassigned", user]);
  const [tab, setTab] = useState<"accounts" | "users">("accounts");

  const automations = useSignalAutomations({
    workspaceId: workspace?.id,
    automationId,
    status: signalStatus,
    playbookId,
    enabled: !!workspace?.id,
    retry: 0,
  }) as any;

  // Reset selected signal to first value when tab changes
  useEffect(() => {
    setAutomationId(automations?.data?.[0]?.id || undefined);
  }, [tab]);

  useEffect(() => {
    if (!automationId && automations?.data?.length > 0) {
      setAutomationId(automations?.data[0]?.id);
    }
  }, [automations?.data]);

  // Filter automations based on account signal requirements
  const filteredAutomations = (Array.isArray(automations?.data) ? automations.data.filter((automation: any) => 
        automation?.entity_relation === tab
      ) : []);

  return (
    <div className={cn("w-full", containerClass)}>
      <SignalsHeader
        signalsData={filteredAutomations}
        showTitle={showTitle}
        navTo={navTo}
        accountSignal={accountSignal}
        period={period}
        owner={owner}
        setOwner={setOwner}
        setPeriod={setPeriod}
        automationId={automationId}
        setAutomationId={setAutomationId}
        playbookId={playbookId}
        setPlaybookId={setPlaybookId}
        signalStatus={signalStatus}
        setSignalStatus={setSignalStatus}
        tab={tab}
        setTab={setTab}
        onTabClick={onTabClick}
      />
      {filteredAutomations?.length ? (
        <SignalsBody
          tableHeight={tableHeight}
          tab={tab}
          workspaceId={workspace.id}
          automationsList={filteredAutomations}
          selectedSignal={selectedSignal}
          containerClass={`border-none ${bodyClass && bodyClass}`}
          owner={owner}
          signalStatus={signalStatus}
          automationId={automationId}
        />
      )
        : <EmptySignalPlaceholder isLoading={automations?.isLoading} className={`${bodyClass || ""}`} />}
    </div>
  );
};

export default SignalsContainer;
